var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"map"},[_c('div',{ref:"tooltip",attrs:{"id":"tooltip"}})])}
var staticRenderFns = []

export { render, staticRenderFns }